<section>
    <header>
        <h2>{{ title }}</h2>
    </header>

    <form [formGroup]="serverForm" (ngSubmit)="save()" fxLayout="column" fxLayoutAlign="space-around stretch">

        <div fxLayout="row" fxLayoutAlign="space-between stretch">
            <mat-form-field fxFlex="59">
                <input matInput #input placeholder="Name*" type="text" formControlName="name" autocomplete="off"
                    maxlength="100" />
                    <mat-error matErrorMessages></mat-error>
                    <mat-hint align="end">{{ input.value?.length || 0 }}/100</mat-hint>
            </mat-form-field>

            <mat-form-field fxFlex="39">
                <input matInput placeholder="Environment*" type="text" formControlName="environment"
                    autocomplete="off" />
                <mat-error matErrorMessages></mat-error>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between stretch">
            <mat-form-field fxFlex="59">
                <input matInput placeholder="URL*" type="text" formControlName="url" autocomplete="off" />
                <mat-error matErrorMessages></mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="18.5">
                <input matInput placeholder="Port*" type="text" formControlName="port" autocomplete="off"
                    maxlength="4" />
                <mat-error matErrorMessages></mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="18.5">
                <input matInput placeholder="Endpoint" type="text" formControlName="endpoint" autocomplete="off" />
                <mat-error matErrorMessages></mat-error>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between stretch">
            <mat-form-field fxFlex="49">
                <input matInput placeholder="User*" type="text" formControlName="user" autocomplete="off" />
                <mat-error matErrorMessages></mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="49">
                <mat-icon *ngIf="isVisible" matSuffix (click)="isVisible = !isVisible;">visibility</mat-icon>
                <mat-icon *ngIf="!isVisible" matSuffix (click)="isVisible = !isVisible;">visibility_off</mat-icon>
                <input matInput placeholder="Password*" [type]="isVisible ? 'text' : 'password'" formControlName="password"
                    autocomplete="password" />
                <mat-error matErrorMessages></mat-error>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="end">
            <button type="button" mat-raised-button (click)="dialogRef.close(false)" color="warn"
                style="margin-right: 1em;">Cancel</button>
            <button type="submit" mat-raised-button color="primary" [class.spinner]="loading" 
                [disabled]="loading || serverForm.invalid">Save</button>
        </div>
    </form>
</section>